import { useEffect, useState } from 'react'
import { DAY_IN_SECONDS, isPhone } from '../common/constants'
import { TimeRangeNavigation, TimeRange } from '../components'
import { useAccountContext } from '../contexts'
import { ManageDataByCharts } from './ManageDataByCharts'
import { Layout } from '../layouts/Layout'
import { Viewport } from '../common/types'

export const DEFAULT_DATE_PERIOD_IN_MS = 14 * DAY_IN_SECONDS * 1000

export function ManageDataPage() {
  const { selectedDevice, selectDevice } = useAccountContext()
  const path = window.location.pathname

  const [viewport, setViewport] = useState<Viewport>({
    minimum: new Date().setHours(0, 0, 0, 0) - DEFAULT_DATE_PERIOD_IN_MS,
    maximum: new Date().setHours(23, 59, 59, 999),
  })

  const [timeRange, setTimeRange] = useState<TimeRange>({
    preset: 'week',
    from: new Date().setHours(0, 0, 0, 0) - DEFAULT_DATE_PERIOD_IN_MS,
    to: new Date().setHours(23, 59, 59, 999),
    label: '14 days',
  })

  useEffect(() => {
    !isPhone && selectDevice('')
  }, [path]) // eslint-disable-line react-hooks/exhaustive-deps

  function handleTimeRangeChange(newRange: TimeRange) {
    setTimeRange(newRange)
    if (newRange.from && newRange.to) {
      setViewport({
        minimum: newRange.from,
        maximum: newRange.to,
      })
    }
  }

  return (
    <Layout>
      <div>
        <div className="flex flex-row mb-4">
          <TimeRangeNavigation currentRange={timeRange} onRangeChange={handleTimeRangeChange} />
        </div>
        <div className="overflow-y-auto overflow">
          <ManageDataByCharts sigfoxId={selectedDevice} viewport={viewport} />
        </div>
      </div>
    </Layout>
  )
}
